export default "<div *ngIf=\"shouldShowErrors()\">\n  <small *ngFor=\"let error of listOfErrors()\">\n    {{ error }}\n  </small>\n</div>\n"